(function () {
    'use strict';

    /**
     * @ngdoc object
     * 
     *
     * @description
     *
     */
    angular
        .module('missingSignIn')
        .controller('deadlineExtendCtrl', deadlineExtendCtrl);

    function deadlineExtendCtrl($uibModalInstance, modalParams, MissingSignInService, MessageService,EventManagerService) {
        var vm = this;
        vm.ctrlName = 'reportActivationCtrl';
        
        vm.model = {
        		deadline: {
            	crewScheduleBlockId : modalParams.crewScheduleBlockId,
            	extendtime : 24
            }
        };

        vm.extendDeadline = function () {
        	MissingSignInService.extendDeadline(vm.model.deadline,
                  function (response) {
                     if (response.success) {
	                    	$uibModalInstance.close();
	                        MessageService.success(MessageService.MESSAGES.CREWING.SUCCESS_SAVE_MESSAGE);
	                		EventManagerService.notifyEventListeners(EventManagerService.EVENT.MISSIN_SIGN_IN.RELOAD_SIGN_OUT_DATA);
                        }
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                )
         };

        vm.closeMe = function () {
            $uibModalInstance.close();
        };
    }
}());
